import { Controller } from '@hotwired/stimulus';
import {
  hide as hideArticleActions,
  show as showArticleActions,
} from '@controllers/main/article-actions_controller';
import queryString from 'query-string';

export default class extends Controller {
  static targets = ['content', 'navbar', 'topbar'];
  static values = {
    wasScrollingDown: { type: Boolean, default: false },
  };

  connect() {
    if (
      !this.hasContentTarget ||
      !this.hasNavbarTarget ||
      !this.hasTopbarTarget
    )
      return false;

    const query = queryString.parse(window.location.search);
    if (query?.preview === 'true') {
      hideArticleActions();
      this.hideTopbar();
    } else {
      window.addEventListener('scroll', this.handleScrollChange.bind(this));
      this.updateCurrentScrollPosition();
      this.handleScrollChange();
    }
  }

  handleScrollChange() {
    if (this.isScrollPositionInsideOrAboveArticle()) {
      if (this.isScrollingDown()) {
        if (this.wasScrollingDownValue !== true) {
          this.hideTopbar();
          hideArticleActions();
          this.wasScrollingDownValue = true;
        }
      } else {
        if (this.wasScrollingDownValue === true) {
          this.showTopbar();
          showArticleActions();
          this.wasScrollingDownValue = false;
        }
      }
    } else {
      this.showTopbar();
    }

    this.updateCurrentScrollPosition();
  }

  updateCurrentScrollPosition() {
    this.previousScrollPosition = this.detectScrollPosition();
  }

  detectScrollPosition() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  isScrollPositionInsideOrAboveArticle() {
    const navbarPosFromTop = this.navbarTarget.getBoundingClientRect().top * -1;
    const navbarHeight = this.navbarTarget.clientHeight;
    const navbarOutOfView = navbarHeight - navbarPosFromTop < 0;

    const contentPosFromTop = this.contentTarget.getBoundingClientRect().top;
    const contentHeight = this.contentTarget.clientHeight;
    const halfWindowHeight = window.innerHeight / 2;
    const contentStillHalfInView =
      contentPosFromTop - halfWindowHeight + contentHeight > 0;

    return navbarOutOfView & contentStillHalfInView;
  }

  isScrollingDown() {
    return this.previousScrollPosition < this.detectScrollPosition();
  }

  hideTopbar() {
    this.topbarTarget.classList.add('navbar-hidden');
  }

  showTopbar() {
    this.topbarTarget.classList.remove('navbar-hidden');
  }
}
